const gsap = window.gsap;

export default function initBannerAndMenu(){
  // no-hover на первой тач
  (function () {
    const rootEl = document.documentElement;
    function addNoHover() { rootEl.classList.add('no-hover'); }
    window.addEventListener('touchstart', addNoHover, { passive: true, once: true });
  })();

  // PRM / форс анимаций
  const forceAnim =
      /[?&]anim=1\b/.test(location.search) ||
      document.documentElement.dataset.ignorePrm === '1';
  const prefersReduced = forceAnim ? false : matchMedia('(prefers-reduced-motion: reduce)').matches;

  gsap.ticker.lagSmoothing(1000, 16);

  gsap.set(['.driven', '.forward'], { autoAlpha: 0, y: 30, force3D: true });
  gsap.set(['.ellipse-49', '.circle-text', '.interface-essential-arrow-down'], { autoAlpha: 0, force3D: true });

  const isPortraitMobile = window.matchMedia("(orientation: portrait) and (max-width: 744px)").matches;
  const tl = gsap.timeline({ onStart: () => document.body.classList.remove('prehide') });

  const root   = document.querySelector('.animated-circle');
  const circle = document.querySelector('.circle-text');
  const arrow  = document.querySelector('.interface-essential-arrow-down .group');

  let INIT_ROT = 0;
  let idleSpin = null;
  let idleArrow = null;
  let hoverBound = false;

  tl.set(['.ellipse-49', '.circle-text', '.interface-essential-arrow-down'], { opacity: 0 });

  if (isPortraitMobile) {
    tl.fromTo('.driven', { y: 30, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 1.25, ease: 'power3.out', force3D: true })
        .fromTo('.forward', { y: 30, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 1.15, ease: 'power3.out', force3D: true }, "-=0.15")
        .to('.ellipse-49', { autoAlpha: 1, duration: 1.0, ease: 'power3.out' }, "-=0.15")
        .to(['.circle-text', '.interface-essential-arrow-down'], { autoAlpha: 1, duration: 0.9, ease: 'power3.out' }, "<")
        .add(onIntroComplete);
  } else {
    tl.fromTo('.driven', { y: 30, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 1.25, ease: 'power3.out', force3D: true })
        .to(['.ellipse-49'], { autoAlpha: 1, duration: 1, ease: 'power3.out' }, "-=0.35")
        .to(['.circle-text', '.interface-essential-arrow-down'], { autoAlpha: 1, duration: 0.9, ease: 'power3.out' }, "<")
        .fromTo('.forward', { y: 30, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 1.15, ease: 'power3.out', force3D: true }, "-=0.15")
        .add(onIntroComplete);
  }

  function onIntroComplete() {
    if (!circle) return;
    INIT_ROT = gsap.getProperty(circle, 'rotation') || 0;
    if (!prefersReduced) startIdleLoop();  // respect PRM
    bindHoverOnce();
  }
  function startIdleLoop() {
    if (!circle) return;
    if (idleSpin) idleSpin.kill();
    if (!prefersReduced) {
      idleSpin = gsap.to(circle, { rotation: '+=360', duration: 24, ease: 'none', repeat: -1, transformOrigin: '50% 50%', force3D: true });
    }
    if (arrow) {
      if (idleArrow) idleArrow.kill();
      if (!prefersReduced) {
        idleArrow = gsap.to(arrow, { y: 10, duration: 1.25, ease: 'sine.inOut', yoyo: true, repeat: -1, force3D: true });
      }
    }
  }
  function nearestToInitial(current, initial) { return initial + 360 * Math.round((current - initial) / 360); }
  function bindHoverOnce() {
    if (hoverBound || !root || !circle) return;
    hoverBound = true;
    root.addEventListener('mouseenter', () => {
      if (idleSpin) idleSpin.pause();
      const cur = gsap.getProperty(circle, 'rotation');
      const dest = nearestToInitial(cur, INIT_ROT);
      gsap.to(circle, { rotation: dest, duration: 0.6, ease: 'power3.out', overwrite: 'auto' });
    });
    root.addEventListener('mouseleave', () => { if (idleSpin) idleSpin.resume(); });
  }

  const circleBtn = document.querySelector('.animated-circle');
  const target = document.querySelector('.values');
  const fix_header = document.querySelector('header');
// ==== smooth scroll (надёжный) ====
  let __scrollAnim = null;

  function smoothScrollTo(targetY, { duration = 700, onDone } = {}) {
    const html = document.documentElement;
    const body = document.body;
    const scroller = document.scrollingElement || html;

    // если можно нативно и PRM не просит reduce → нативный smooth
    const canNativeSmooth = 'scrollBehavior' in html.style &&
        !(matchMedia('(prefers-reduced-motion: reduce)').matches) &&
        !document.documentElement.dataset.ignorePrm;

    const startY = scroller.scrollTop;
    const delta  = Math.round(targetY - startY);
    if (Math.abs(delta) < 1) { onDone && onDone(); return; }

    // отмена предыдущей анимации
    if (__scrollAnim && __scrollAnim.stop) __scrollAnim.stop();

    if (canNativeSmooth) {
      const stop = () => {
        window.removeEventListener('wheel', stop, { passive:true });
        window.removeEventListener('touchstart', stop, { passive:true });
        onDone && onDone();
      };
      window.addEventListener('wheel', stop, { passive:true, once:true });
      window.addEventListener('touchstart', stop, { passive:true, once:true });
      scroller.scrollTo({ top: targetY, behavior: 'smooth' });
      // страховка, если браузер не диспатчит scrollend:
      setTimeout(stop, Math.max(300, duration + 100));
      __scrollAnim = { stop };
      return;
    }

    // rAF-fallback
    const prevHtml = html.style.scrollBehavior;
    const prevBody = body.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    body.style.scrollBehavior = 'auto';

    let startTs = null, rafId = 0, stopped = false;
    const ease = t => (t < .5 ? 2*t*t : 1 - Math.pow(-2*t + 2, 2)/2);

    const stop = () => {
      if (stopped) return;
      stopped = true;
      cancelAnimationFrame(rafId);
      html.style.scrollBehavior = prevHtml;
      body.style.scrollBehavior = prevBody;
      onDone && onDone();
    };
    __scrollAnim = { stop };

    const cancelOnInput = () => stop();
    window.addEventListener('wheel', cancelOnInput, { passive:true, once:true });
    window.addEventListener('touchstart', cancelOnInput, { passive:true, once:true });

    const step = ts => {
      if (stopped) return;
      if (startTs === null) startTs = ts;
      const p = Math.min(1, (ts - startTs) / duration);
      scroller.scrollTop = startY + delta * ease(p);
      if (p < 1) rafId = requestAnimationFrame(step); else stop();
    };
    rafId = requestAnimationFrame(step);
  }



  if (circleBtn && target && fix_header) {
    circleBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (document.body.classList.contains('menu-open')) return; // не скроллим при залоченном body

      const headerH = fix_header.getBoundingClientRect().height || fix_header.offsetHeight || 0;
      const targetTop = target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);
      const y = targetTop - headerH;

      smoothScrollTo(y, {
        duration: 700,
        onDone: () => {
          // важно: после программного скролла освежаем лэйауты/триггеры
          if (window.ScrollTrigger && ScrollTrigger.refresh) {
            ScrollTrigger.refresh(true);
          }
        }
      });
    });
  }





  const header  = document.querySelector('.header');
  const burger  = document.querySelector('.header__burger');
  const overlay = document.querySelector('.overlay');

  const onScroll = () => {
    if (!header) return;
    if (document.body.classList.contains('menu-open')) return;
    header.classList.toggle('header--scrolled', window.scrollY > 8);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  let __prevScrollBehavior = '';
  const getScrollY = () => window.pageYOffset || document.documentElement.scrollTop || 0;

  const TOUCHMOVE_OPTS = { passive: false, capture: true };

  const lockBodyScroll = () => {
    __prevScrollBehavior = document.documentElement.style.scrollBehavior || '';
    document.documentElement.style.scrollBehavior = 'auto';
    const y = getScrollY();
    document.body.dataset.scrollY = String(y);
    const sbw = window.innerWidth - document.documentElement.clientWidth;
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    document.body.style.position = 'fixed';
    document.body.style.top      = `-${y}px`;
    document.body.style.left     = '0';
    document.body.style.right    = '0';
    document.body.style.width    = '100%';
    document.body.classList.add('menu-open');
  };
  const unlockBodyScroll = () => {
    const y = parseInt(document.body.dataset.scrollY || '0', 10) || 0;
    document.body.classList.remove('menu-open');
    document.body.style.position = '';
    document.body.style.top      = '';
    document.body.style.left     = '';
    document.body.style.right    = '';
    document.body.style.width    = '';
    document.body.style.paddingRight = '';
    delete document.body.dataset.scrollY;
    window.scrollTo(0, y);
    requestAnimationFrame(() => { document.documentElement.style.scrollBehavior = __prevScrollBehavior; });
  };

  const blockTouchMove = (e) => {
    if (document.body.classList.contains('menu-open') && !overlay.contains(e.target)) {
      e.preventDefault();
    }
  };

  if (burger && overlay) {
    const setHidden = (isHidden) => overlay.toggleAttribute('hidden', isHidden);
    const closeMenu = () => {
      overlay.classList.remove('active');
      burger.classList.remove('active');
      header && header.classList.remove('header--menu-open');
      burger.setAttribute('aria-expanded','false');
      setHidden(true);
      unlockBodyScroll();
      document.removeEventListener('touchmove', blockTouchMove, TOUCHMOVE_OPTS);
    };
    const toggleMenu = () => {
      const willOpen = !overlay.classList.contains('active');
      overlay.classList.toggle('active', willOpen);
      burger.classList.toggle('active', willOpen);
      header && header.classList.toggle('header--menu-open', willOpen);
      burger.setAttribute('aria-expanded', String(willOpen));
      setHidden(!willOpen);
      if (willOpen) {
        lockBodyScroll();
        document.addEventListener('touchmove', blockTouchMove, TOUCHMOVE_OPTS);
      } else {
        closeMenu();
      }
    };
    burger.addEventListener('click', toggleMenu);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) closeMenu(); });
    overlay.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMenu(); });
  }

  if (window.__DEBUG__) {
    document.addEventListener('touchmove', (e) => {
      if (document.body.classList.contains('menu-open')) {
        console.warn('scroll locked by menu-open');
      }
    }, { passive: true });
  }
}
